import React from "react";
import iconVerified   from "../../assets/icon-c2pa-verified.svg";
import iconAccessible from "../../assets/icon-accessible.svg";
import iconSecure     from "../../assets/icon-secure.svg";
import knightIc from "../../assets/knight.png";
import smartIc from "../../assets/smart.png";
import summitIc from "../../assets/summit.png";
import cranesIc from "../../assets/cranes.png";
import hydroIc from "../../assets/hydro.png";

const BADGES = [
    {
        icon: iconVerified,
        title: "C2PA Verified",
        desc: "Every record is cryptographically signed and tamper-proof",
    },
    {
        icon: iconAccessible,
        title: "Accessible Anywhere",
        desc: "Mac, mobile and desktop access from anywhere in the world",
    },
    {
        icon: iconSecure,
        title: "Secure & Private",
        desc: "Bank-grade security to keep your data and projects safe",
    },
];

const COMPANIES = [
    { name: "21 Knights",             logo: knightIc  },
    { name: "SmartConstructs",        logo: smartIc   },
    { name: "Summit Partners",        logo: summitIc  },
    { name: "8Cranes",                logo: cranesIc  },
    { name: "Hydro Spring Engineers", logo: hydroIc   },
];

const PricingTrust = () => {
    return (
        <div className="ptrust-wrapper">
            {/* Three trust badges */}
            <div className="ptrust-badges">
                {BADGES.map((b, i) => (
                    <div key={i} className="ptrust-badge-card">
                        <div className="ptrust-badge-icon-wrap">
                            <img src={b.icon} alt={b.title} className="ptrust-badge-icon" />
                        </div>
                        <div className="ptrust-badge-text">
                            <span className="ptrust-badge-title">{b.title}</span>
                            <span className="ptrust-badge-desc">{b.desc}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Trusted by companies */}
            <div className="ptrust-companies">
                <p className="ptrust-companies-title">Trusted by Top-global construction companies</p>
                <div className="ptrust-logos">
                    {COMPANIES.map((c, i) => (
                        <img key={i} src={c.logo} alt={c.name} className="ptrust-logo" />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingTrust;
